/*import {githubAuthApiRef,} from '@backstage/core-plugin-api';*/
import {oidcAuthApiRef} from "../../apis.ts";
import {SignInProviderConfig} from "@backstage/core-components";

/*
const gitHubProvider: SignInProviderConfig = {
    id: 'github-auth-provider',
    title: 'GitHub',
    message: 'Clique aqui para fazer login com sua conta GitHub',
    apiRef: githubAuthApiRef,
};
*/

const keycloakProvider: SignInProviderConfig = {
    id: 'keycloak',
    title: 'SSO',
    message: 'Clique aqui para fazer login com sua conta corporativa',
    apiRef: oidcAuthApiRef,
};

export const providers = [
    /*gitHubProvider,*/ keycloakProvider
];
